import React from 'react';
import { I18n } from 'react-redux-i18n';

import { I18N_BASE } from '../../constants';
import styles from './modals.module.css';

export interface CollateralStats {
  otherPending: number;
  donations: number | null;
  donationCount: number | null;
  category: string;
}

export interface CollateralSummaryCardProps {
  stats: CollateralStats;
  testId?: string;
}

function formatNumber(value: number | null): string {
  if (value == null) return '—';
  return value.toLocaleString();
}

function formatCurrency(value: number | null): string {
  if (value == null) return '—';
  return value.toLocaleString(undefined, { style: 'currency', currency: 'AUD' });
}

export function CollateralSummaryCard({
  stats,
  testId,
}: CollateralSummaryCardProps): React.ReactElement {
  return (
    <div className={styles.summaryGrid} data-testid={testId}>
      {stats.otherPending > 0 ? (
        <div className={styles.stat}>
          <span className={styles.statLabel}>
            {I18n.t(`${I18N_BASE}.blockModal.summary.otherPending`)}
          </span>
          <span className={styles.statValue}>{formatNumber(stats.otherPending)}</span>
        </div>
      ) : null}
      <div className={styles.stat}>
        <span className={styles.statLabel}>
          {I18n.t(`${I18N_BASE}.blockModal.summary.donations`)}
        </span>
        <span className={styles.statValue}>{formatCurrency(stats.donations)}</span>
      </div>
      <div className={styles.stat}>
        <span className={styles.statLabel}>
          {I18n.t(`${I18N_BASE}.blockModal.summary.donationCount`)}
        </span>
        <span className={styles.statValue}>{formatNumber(stats.donationCount)}</span>
      </div>
      <div className={styles.stat}>
        <span className={styles.statLabel}>
          {I18n.t(`${I18N_BASE}.blockModal.summary.category`)}
        </span>
        <span className={styles.statValue}>{stats.category}</span>
      </div>
    </div>
  );
}

export default CollateralSummaryCard;
